export const SET_WATCHES = 'SET_WATCHES';
export const DELETE_WATCH = 'DELETE_WATCH';
